module.exports = __webpack_public_path__ + "img/top_yuyue@3x.3dfdf0a1.png";